export const CommonTemplates = {
  VAMOS: 'VAMOS',
  LENGO: 'LENGO',
  NIGUS: 'NIGUS',
  LENGOGAMES: 'LENGOGAMES',
};

export const HomeLoadingTemplate = {
  ...CommonTemplates,
  KIMEM: 'KIMEM',
  HULU: 'HULU',
};
export const GamePageVersion = {
  LENGO: 'LENGO',
  LENGOGAMES: 'LENGOGAMES',
  KIMEM: 'KIMEM',
  NIGUS: 'NIGUS',
  VAMOS: 'VAMOS',
  LEGACY: 'LEGACY',
  HULUGAMING: 'HULUGAMING',
};

export const GameItemTemplate = {
  ...CommonTemplates,
  HULUSPORT: 'HULUSPORT',
};

export const GameCategoryTemplate = {
  ...CommonTemplates,
  KIMEM: 'KIMEM',
};

export const JackpotBetHistoryTemplate = {
  ...CommonTemplates,
  HULUSPORT: 'HULUSPORT',
};
export const LayOutTemplate = {
  VAMOS: 'VAMOS',
  LENGO: 'LENGO',
  LENGOGAMES: 'LENGOGAMES',
};

export const HomeLayOutTamplate = {
  LENGO: 'LENGO',
  LENGOGAMES: 'LENGOGAMES',
  KIMEM: 'KIMEM',
  NIGUS: 'NIGUS',
  VAMOS: 'VAMOS',
  LEGACY: 'LEGACY',
  HULUSPORT: 'HULUSPORT',
  MULASPORT: 'MULASPORT',
};

export const VirtualSportTemplate = {
  VAMOS: 'VAMOS',
};
export const SingleLobbyTemplate = {
  ...CommonTemplates,
};

export const PromotionsTemplate = {
  ...CommonTemplates,
};
export const RulesTemplate = {
  ...CommonTemplates,
};

export const MobileSportsTemplate = {
  ...CommonTemplates,
};
export const AccountTemplate = {
  ...CommonTemplates,
  MULASPORT: 'MULASPORT',
};

export const ProfileTemplate = {
  ...CommonTemplates,
};

export const WithdrawPageTemplate = {
  ...CommonTemplates,
};
export const DepositPageTemplate = {
  ...CommonTemplates,
};
export const TransferPageTemplate = {
  ...CommonTemplates,
};
export const SignInTemplate = {
  ...CommonTemplates,
  KIMEM: 'KIMEM',
};

export const SignUpTemplate = {
  ...CommonTemplates,
  KIMEM: 'KIMEM',
  HULUSPORT: 'HULUSPORT',
};

export const ProfileLayoutTemplate = {
  ...CommonTemplates,
  HULUSPORT: 'HULUSPORT',
  KIMEM: 'KIMEM',
};
export const MobileMenueTemplate = {
  ...CommonTemplates,
  TOPBET: 'TOPBET',
};
export const MobileSearchTemplate = {
  ...CommonTemplates,
};
export const PlacedBetDataViewer = {
  ...CommonTemplates,
};
export const MobilUserMenuDrawerTemplate = {
  ...CommonTemplates,
};

export const WalletPageTemplate = {
  ...CommonTemplates,
  MULASPORT: 'MULASPORT',
  HULUSPORT: 'HULUSPORT',
};
export const BetHistoryTemplate = {
  ...CommonTemplates,
  LEGACY: 'LEGACY',
  KIMEM: 'KIMEM',
};
export const BetHistoryDetailTemplate = {
  ...CommonTemplates,
  LEGACY: 'LEGACY',
  KIMEM: 'KIMEM',
  HULUSPORT: 'HULUSPORT',
};

export const LoginPageTemplate = {
  ...CommonTemplates,
  KIMEM: 'KIMEM',
};

export const CreateAccountPageTemplate = {
  ...CommonTemplates,
  KYC: 'KYC',
};

export const TransactionPageTemplate = {
  ...CommonTemplates,
  MULASPORT: 'MULASPORT',
  HULUSPORT: 'HULUSPORT',
};
export const RightBarTemplate = {
  ...CommonTemplates,
  MULASPORT: 'MULASPORT',
  LEGACY: 'LEGACY',
};
export const LeftBarTemplate = {
  ...CommonTemplates,
  MULASPORT: 'MULASPORT',
  LEGACY: 'LEGACY',
  TOPBET: 'TOPBET',
};
export const AccumulatorTemplate = {
  ...CommonTemplates,
  LEGACY: 'LEGACY',
};
export const FooterTemplate = {
  ...CommonTemplates,
  TOPBET: 'TOPBET',
  LEGACY: 'LEGACY',
  LENGODEFAULT: 'LENGODEFAULT',
};
export const MatchDetailTemplate = {
  ...CommonTemplates,
  TOPBET: 'TOPBET',
};
export const UpcomingMatchsTemplate = {
  ...CommonTemplates,
  TOPBET: 'TOPBET',
  LEGACY: 'LEGACY',
  LENGODEFAULT: 'LENGODEFAULT',
};
export const TopLeagueMatchsTemplate = {
  ...CommonTemplates,
  TOPBET: 'TOPBET',
  LEGACY: 'LEGACY',
  LENGODEFAULT: 'LENGODEFAULT',
};

export const TodayMatchsTemplate = {
  ...CommonTemplates,
  TOPBET: 'TOPBET',
  LEGACY: 'LEGACY',
  LENGODEFAULT: 'LENGODEFAULT',
};
export const TodayMatchCardTemplate = {
  ...CommonTemplates,
  TOPBET: 'TOPBET',
  LEGACY: 'LEGACY',
  LENGODEFAULT: 'LENGODEFAULT',
};

export const MatchsSortBy = {
  LEAGUE: 'LEAGUE',
  TIME: 'TIME',
};

export const FooterMobileNavTemplateOptions = {
  ...CommonTemplates,
  HULUSPORT: 'HULUSPORT',
  LENGOGAMES: 'LENGOGAMES',
  LENGODEFAULT: 'LENGODEFAULT',
  HULUGAMING: 'HULUGAMING',
};
export const EventsTemplate = {
  ...CommonTemplates,
};
export const MatchViewTemplate = {
  ...CommonTemplates,
  NIGUS: 'NIGUS',
  KIMEM: 'KIMEM',
};

export const SideDrawerTemplate = {
  ...CommonTemplates,
  LEGACY: 'LEGACY',
};

export const SlipCardTemplate = {
  ...CommonTemplates,
  KIMEM: 'KIMEM',
};

export const TrendingTemplate = {
  ...CommonTemplates,
  LEGACY: 'LEGACY',
};
export const TopNavBarTemplate = {
  ...CommonTemplates,
  LEGACY: 'LEGACY',
  LENGOGAMES: 'LENGO_GAMES',
};

export const HEADER_TEMPALTE = {
  LENGO: 'LENGO',
  VAMOS: 'VAMOS',
  HULUSPORT: 'HULUSPORT',
  LEGACY: 'LEGACY',
  MULASPORT: 'MULASPORT',
};

export const MobileNavBarVersion = {
  HULUSPORT: 'HULUSPORT',
  GURSHAFOOTER: 'GURSHAFOOTER',
  LEGACY: 'legacy',
  JANO: 'jano',
};

export const RightBarVersion = {
  BETMAN: 'BETMAN',
  GURSHA: 'GURSHA',
  LEGACY: 'legacy',
  JANO: 'JANO',
};

export const MarketMobileVersion = {
  VARIANT1: 'variant1',
  VARIANT2: 'variant2',
  JANO: 'jano', //  three-way market
  FRANK: 'frank',
};

export const BetHistoryFilterType = {
  ALL: 'all',
  DATE: 'date',
  STATUS: 'status',
};
export const BetHistoryCardTemplate = {
  ...CommonTemplates,
  LEGACY: 'LEGACY',
};

export const DateTimeFilterTemplate = {
  LEGACY_FILTER: 'LegacyDayFilter',
  DATETIME_FILTER: 'DateTimeFilter',
  ZEMEN_DATE_FILTER: 'ZemenDayFilter',
};

export const MobileDepositTemplate = {
  SOCCER: 'Soccer',
  ZEMEN: 'Zemen',
};

export const BetMatchListTemplate = {
  LEGACY: 'Legacy',
  GURSHA: 'GURSHA',
};

export const PromotionVersion = {
  PROMO_LIST: '/promotion',
  NEW_REWARDS: '/my-awards-and-promotions',
};

const LIVECHAT = {
  NONE: 'none',
  TAWK: 'tawk',
  SOCIAL: 'social',
};
const NEWCASINOSHOWALL = {
  REDIRECT: 'redirect',
  SAMEPAGE: 'same-page',
};
const FALLBACKLANG = {
  EN: 'En',
  AM: 'Am',
  Fr: 'Fr',
};
const SHOWFILTERBY = {
  DAY: 'day',
  TIME: 'time',
  BOTH: 'both',
};
const GAMESFILTERVERSION = {
  VamosFilters: 'VamosFilters',
  LegacyFilters: 'LegacyFilters',
};
export const appThemeConfiguration = {
  // App/Theme Configuration
  FAVICON: 'logo.png',
  TITLE: 'Lengo',
  THEME: 'LENGO',
  LOADING_LOGO: 'logo.png',
  GOOGLE_TRACKING_ID: '',
  TAWK_ID: '',
  GOOGLE_ANALYTICS_ID: '',
  LIVE_CHAT: LIVECHAT.NONE,

  // Logo and Stake Settings
  LOGO_SIZE: 20,
  LOGO_SIZE_MOBILE: 10,
  MIN_STAKE: 20,
  MAX_STAKE: 5000,

  // UI/UX Settings
  ENABLE_SLIP_NAV: true,
  RIGHTBAR_SCROLL: true,
  TICKET_SCROLL: false,
  STICKY_BANNER: false,
  SCROLLABLE_HOME: false,
  STICKY_HEADER: false,

  // Game Settings
  SHOW_GAMES_SIDEBAR: true,
  SWAP_SPORT_TYPE_DATE_FILTER: true,
  SHOW_GAME_ID: false,
  ENABLE_DOUBLE_CHANCE_DESKTOP: true,
  ENABLE_DOUBLE_CHANCE_MOBILE: true,

  // Display Settings
  IS_LOCAL_TIME: true,
  ABBREVIATE: false,
  MATCHNAME_ONELINE: true,
  ODD_DIVIDER: false,
  TICKET_ROUNDED: false,
  TICKET_HIGHLIGHTED: true,
  SHOW_MULA_FOOTER: true,
  MOBILE_BOTTOM_TAB_INFO: false,
  MATCH_DETAIL_ADD_TO_SLIP_REDIRECT_TO_MATCH_LIST: false,
  MATCH_HEADER_ABBREVIATE: true,
  MATCH_EVENT_TITLE_SHOW_WAY: false,

  // Feature Flags
  DISABLE_FETAN_LEAGUE: false,
  KIRON_GAMES_TAG_SLUG: 'kironlite-games',
  DISABLE_HOME_MOBILE: false,
  DISABLE_AM_LANG: false,
  DISABLE_MATCH_VIEW_TYPE: true,
  SHOW_GAME_MODE_OPTION: true,
  SHOW_FLOATING_SOCIAL_MEDIA: false,
  DISPLAY_GET_BOUNS_ALERT: true,
  DISPLAY_DEPOSIT_ALERT: true,
  ENABLE_CHAPA_DIRECT: true,
  DISABLE_PLACEBET_TERMS_CHECKER: true,
  RAFFLE_ENABLE: true,
  ENABLE_PLACEBET_BONUS: true,

  // Version Settings
  GAME_PAGE_VERSION: GamePageVersion.HULUGAMING,
  SINGLE_LOBBY_VERSION: SingleLobbyTemplate.VAMOS,
  BET_MATCH_LIST_TEMPLATE: BetMatchListTemplate.GURSHA,
  MOBILE_NAV_BAR_VERSION: MobileNavBarVersion.GURSHAFOOTER,
  RIGHT_BAR: RightBarVersion.GURSHA,
  MARKET_MOBILE_VERSION: MarketMobileVersion.VARIANT1,
  HOME_LOADING_VERSION: HomeLoadingTemplate.LENGO,
  HOME_LAYOUT_VERSION: HomeLayOutTamplate.LENGOGAMES,
  VIRTUAL_SPORT_VERSION: VirtualSportTemplate.VAMOS,
  PROMOTION_VERSION: PromotionsTemplate.VAMOS,
  RULE_VERSION: RulesTemplate.VAMOS,
  MOBILE_SPORTS_VERSION: MobileSportsTemplate.VAMOS,
  ACCOUNIT_VETSION: AccountTemplate.MULASPORT,
  PROFILE_VERSION: ProfileTemplate.VAMOS,
  PROFILE_LAYOUT_VERSION: ProfileLayoutTemplate.VAMOS,
  WALLET_PAGE_VERSION: WalletPageTemplate.MULASPORT,
  TRANSACTION_PAGE_VERSION: TransactionPageTemplate.MULASPORT,
  DEPOSITE_PAGE_VERSION: DepositPageTemplate.VAMOS,
  WITHDRAW_PAGE_VERSOION: WithdrawPageTemplate.VAMOS,
  TRANSFER_PAGE_VERSION: TransferPageTemplate.VAMOS,
  BET_HISTORY_VERSION: BetHistoryTemplate.VAMOS,
  JACKPOT_BET_HISTORY_VERSION: JackpotBetHistoryTemplate.VAMOS,
  BET_HISTORY_TEMPLATE: BetHistoryDetailTemplate.VAMOS,
  ACCUMULATOR_VERSION: AccumulatorTemplate.VAMOS,
  TRENDING_VERSION: TrendingTemplate.VAMOS,

  SIGNIN_VERSION: LoginPageTemplate.VAMOS,
  SIGN_UP_VERSION: SignUpTemplate.VAMOS,
  SLIP_RIGHT_BAR_VERSION: RightBarTemplate.MULASPORT,
  CHECK_COUPON_RIGHT_BAR_VERSION: RightBarTemplate.VAMOS,

  FOOTER_VERSION: FooterTemplate.LENGODEFAULT,
  MOBILE_FOOTER_VERSION: FooterTemplate.HULUGAMING,

  HEADER_VERSION: HEADER_TEMPALTE.VAMOS,
  LAYOUT_VERSION: LayOutTemplate.LENGOGAMES,

  MOBILE_SEARCH: true,
  ENABLE_CASHOUT: true,
  GAMES_IS_HOME: false,
  SCROLL_DOUBLE_CHANCE: true,
  ANIMATED_NAV: false,

  // Form Settings
  BIRTH_DATE: false,
  ISSUE_DATE: false,
  EXPIRE_DATE: false,
  INLINE_BET_DATA_VIEW: false,
  VIEW_COUPON_IN_NEW_PAGE: true,
  NAV_ICON_HIGHLIGHT: true,

  FIXED_MATCH_DETAIL_HEADER: false,
  MOBILE_DEPOSIT_TEMPLATE: MobileDepositTemplate.SOCCER,

  // Aggregator Settings
  AGGREGATOR_ORDER: ['chappa', 'arifpay', 'santim'],
  ENABLE_ChAPA_DIRECT_INTEGRATION: false,
  ENABLE_MOMO_WITHDRAW_OTP: false,
  ENABLE_EMALI_WITHDRAW_OTP: false,

  // New Features
  FREEBET_VERSION: false,
  ENABLE_LUCKY_WHEEL: true,
  ENABLE_RAFFLE_FEATURE: true,
  PROMOTION_PAGE_PATH: PromotionVersion.NEW_REWARDS,
  ENABLE_ONLINE_TICKET_RETRIEVE: true,
  DISNABLE_OFFLINE_TICKET_RETRIEVE: false,
  ENABLE_RAFFLE_CONTEST: true,

  // Tracking Settings
  GENIUS_TRACKING_ID: '',
  GENIUS_CLIENT_PREFIX: '',

  // Filtering Settings
  DATE_FILTER: true,
  SPORT_TYPE_FILTER: false,
  APP_HOUR_DATE_FILTERING: true,
  DATETIME_FILTER_TEMPLATE: DateTimeFilterTemplate.ZEMEN_DATE_FILTER,

  AD_CLICK_ID_TRACKER: false,

  // DIALOG MANAGER ORDER
  POPUP_MANAGER_ORDER: [
    'RAFFLE_RESULT',
    'TOURNAMENT_POPUP',
    'AFFILIATE_POPUP',
    'INSUFFICIENT',
  ],
  CLOUDFLARE_KEY: null,
  USER_AD_TRACKER: true,
  PAY_BILL: '290070',
  HEADER_ACTION_VERSION: 'legacy',
  CASINO_VERSION: 'new-casino',
  NEW_CASINO_API: true,
  SHOW_DEFAULT_STAKES: true,
  BET_HISTORY_FILTER: BetHistoryFilterType.STATUS,

  SHOW_AVAITOR_ON_NAVBAR: true,

  SHOW_EXPANDED_FOOTER: true,
  SHOW_FIELD: true,
  CENTER_NAVBAR: true,

  ENABLE_EXHIBITION_TICKET: false,
  BACK_NAVIGATION_MATCH_DETAIL: true,
  SHOW_HOME_SPORT_TYPE_FILTER: false,
  NEW_CASINO_SHOW_ALL: NEWCASINOSHOWALL.REDIRECT,
  PLINKO_GAME_GROUP: false,
  KENO_GAME_GROUP: false,
  SPIN_WIN_GAME_GROUP: false,
  FALL_BACK_LANG: FALLBACKLANG.EN,
  GAME_ITEMS_COLOMS: 2,
  SHOW_FILTER_BY: SHOWFILTERBY.DAY,
  GAMES_FILTER_VERSION: GAMESFILTERVERSION.VamosFilters,
  MOBILE_NAV_ITEM_REWARD: true,
  MOBILE_NAV_TEMPLATE: FooterMobileNavTemplateOptions.HULUGAMING,
  ENABLE_FANTASY: true,
};
